var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"flat":""},on:{"click":_vm.toggleSidebar}},[_c('v-icon',[_vm._v("emoji_events")]),_c('span',{staticClass:"ml-2"},[_vm._v("Ranking")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }